module.exports = __webpack_public_path__ + "img/unitingworld.b318c7e.png";